import { c as _c } from "react/compiler-runtime";
import { FilterValue } from "@/shared/types/type/search";
import { TREATMENT_ICON_MAP } from "@/shared/constants/icon-map";
import { Typography } from "@/shared/ui/atoms";
import Link from "next/link";
import { useSearchUiStore } from "@/features/search/model/ui/store";
interface TreatmentSearchListProps {
  treatmentList: FilterValue[];
}
const TreatmentSearchList = t0 => {
  const $ = _c(9);
  const {
    treatmentList
  } = t0;
  const {
    selectedSubRegions
  } = useSearchUiStore();
  let queryRegion;
  if ($[0] !== selectedSubRegions) {
    queryRegion = "";
    if (selectedSubRegions.length > 0) {
      queryRegion = `&region=${selectedSubRegions.map(_temp).join(",")}`;
    }
    $[0] = selectedSubRegions;
    $[1] = queryRegion;
  } else {
    queryRegion = $[1];
  }
  let t1;
  if ($[2] !== queryRegion || $[3] !== treatmentList) {
    let t2;
    if ($[5] !== queryRegion) {
      t2 = (item, index) => {
        const IconComponent = TREATMENT_ICON_MAP[item.id as keyof typeof TREATMENT_ICON_MAP];
        return <div key={`treatment-filter-modal-body-item-${index}`} className="flex flex-col items-center gap-[6px]"><div className="flex justify-start items-center p-2 rounded-[16px] border-gray-100 border"><Link href={`/search/result?treatment=${item.id}${queryRegion}`} className="flex items-center justify-start gap-1">{IconComponent && <IconComponent className="text-gray-400" size={32} />}</Link></div><Typography size={13} lineHeight={14} className="text-start text-gray-600 font-medium" whitespace="nowrap">{item.name}</Typography></div>;
      };
      $[5] = queryRegion;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = treatmentList.map(t2);
    $[2] = queryRegion;
    $[3] = treatmentList;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <>{t1}</>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default TreatmentSearchList;
function _temp(region) {
  return region.id;
}